import { render } from "./ActivationView.vue?vue&type=template&id=9bf96726&scoped=true&ts=true"
import script from "./ActivationView.vue?vue&type=script&lang=ts"
export * from "./ActivationView.vue?vue&type=script&lang=ts"

import "./ActivationView.vue?vue&type=style&index=0&id=9bf96726&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bf96726"]])

export default __exports__